import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PROCESS_STEP_STATUS } from './constants';
import { resolveStepStatus } from './helpers';

// One row of the process: numbered badge with the connector line, title, optional error
// line and the step's content (children). Composed by ProcessStep; exported for hand-built
// sequences.
const ProcessStepItem = ({
    number,
    title,
    status,
    error,
    isLast = false,
    className,
    children,
}) => {
    const resolved = resolveStepStatus(status);
    return (
        <li
            className={classNames(
                'ds-process-step__item',
                `ds-process-step__item--${resolved}`,
                { 'ds-process-step__item--last': isLast },
                className,
            )}
        >
            <span className="ds-process-step__badge" aria-hidden="true">
                {number}
            </span>
            <div className="ds-process-step__body">
                {title != null && title !== '' && <div className="ds-process-step__title">{title}</div>}
                {error && (
                    <div className="ds-process-step__error" role="alert">
                        {error}
                    </div>
                )}
                {children && <div className="ds-process-step__content">{children}</div>}
            </div>
        </li>
    );
};

ProcessStepItem.propTypes = {
    /** Number shown in the badge */
    number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    /** Step title */
    title: PropTypes.node,
    /** Badge state: default / completed / done */
    status: PropTypes.oneOf(Object.values(PROCESS_STEP_STATUS)),
    /** Error text under the title */
    error: PropTypes.node,
    /** Last row: no connector line below the badge */
    isLast: PropTypes.bool,
    /** Extra class on the row */
    className: PropTypes.string,
    /** Step content (form controls, text…) */
    children: PropTypes.node,
};

export default ProcessStepItem;
